import { TextareaControlConfig } from "./textarea-control-config.model";
import { Control } from "../../business-objects/control/control.model";

export type ITextareaFieldValue = string;

export class TextareaControl extends Control {
    config: TextareaControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/textarea/textarea-control.model.ts